import urls from "global/constants/UrlConstants";
import { getCallParams, makeCall } from "utils/service";
import {
  IpAllowlistAuditEvent,
  IpAllowlistEntry,
  IpAllowlistEntryInput,
  IpAllowlistEntryPatch,
  IpAllowlistView,
} from "./WhitelistIPsTypes";

// 1. GET the allowlist + enabled flag. Self-heals legacy entries with ids.
export const fetchIpAllowlist = async (): Promise<IpAllowlistView> => {
  try {
    const callParams = await getCallParams("GET");
    return await makeCall(urls.IP_ALLOWLIST_FETCH, callParams);
  } catch (error: any) {
    throw error;
  }
};

// 2. POST add entries (1..N). All-or-nothing batch.
export const addIpAllowlistEntries = async (
  entries: IpAllowlistEntryInput[],
): Promise<IpAllowlistEntry[]> => {
  try {
    const callParams = await getCallParams("POST", entries);
    return await makeCall(urls.IP_ALLOWLIST_ADD, callParams);
  } catch (error: any) {
    throw error;
  }
};

// 3. PATCH update entries by id (partial merge, 1..N).
export const updateIpAllowlistEntries = async (
  patches: IpAllowlistEntryPatch[],
): Promise<IpAllowlistEntry[]> => {
  try {
    const callParams = await getCallParams("PATCH", patches);
    return await makeCall(urls.IP_ALLOWLIST_UPDATE, callParams);
  } catch (error: any) {
    throw error;
  }
};

// 4. DELETE entries by id.
export const deleteIpAllowlistEntries = async (ids: string[]) => {
  try {
    const callParams = await getCallParams("DELETE", ids);
    return await makeCall(urls.IP_ALLOWLIST_DELETE, callParams);
  } catch (error: any) {
    throw error;
  }
};

// 5. PATCH enable/disable the whole allowlist. Returns the full view.
export const updateIpAllowlistEnabled = async (
  enabled: boolean,
): Promise<IpAllowlistView> => {
  try {
    const callParams = await getCallParams("PATCH", { enabled });
    return await makeCall(urls.IP_ALLOWLIST_UPDATE_ENABLED, callParams);
  } catch (error: any) {
    throw error;
  }
};

// 6. GET audit trail (paginated).
export const fetchIpAllowlistAudit = async (
  limit: number = 50,
  offset: number = 0,
): Promise<IpAllowlistAuditEvent[]> => {
  try {
    const url = `${urls.IP_ALLOWLIST_AUDIT}?limit=${limit}&offset=${offset}`;
    const callParams = await getCallParams("GET");
    return await makeCall(url, callParams);
  } catch (error: any) {
    throw error;
  }
};
